var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { H4, H5, P } from '../../base';
import Select from '../../Forms/Fields/ReusableSelect';
import { PropertiesGroup, PropertiesPage } from '../../PropertiesBar';
import { RowComponent } from './PropertiesRow';
import { key, getSortedTargetProperties, propertyMapper, formatTargetPropertiesForSendDeepLinkedPush, } from './helpers';
var PropertiesMapper = /** @class */ (function (_super) {
    __extends(PropertiesMapper, _super);
    function PropertiesMapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderRowComponent = function () {
            var _a = _this.props, edgeMeta = _a.edgeMeta, selectedEdge = _a.selectedEdge, sourcePatch = _a.sourcePatch, targetPatch = _a.targetPatch, targetProperties = _a.targetProperties, sourceProperties = _a.sourceProperties, onEdgeUpdated = _a.onEdgeUpdated, receiverApps = _a.receiverApps;
            var sourceOptions = sourceProperties;
            if (sourcePatch.logic === 'input') {
                sourceOptions = sourceProperties.filter(function (item) { return !item.dataField.includes('var'); });
            }
            var formattedOptions = sourceOptions.map(function (p) { return ({
                value: p.dataField,
                label: "".concat(sourcePatch.name, " / ").concat(p.dataField),
                type: propertyMapper[p.type] || p.type,
            }); });
            var formattedTargetProperties = getSortedTargetProperties(targetProperties, edgeMeta);
            var formattedTargetPropertiesForSendDeepLinkedPush = formatTargetPropertiesForSendDeepLinkedPush(formattedTargetProperties, receiverApps);
            return formattedTargetPropertiesForSendDeepLinkedPush.map(function (row, index) {
                return (_jsx(RowComponent, { targetPatch: targetPatch, row: row, sourceProperties: sourceProperties, selectedEdge: selectedEdge, onEdgeUpdated: onEdgeUpdated, options: formattedOptions.filter(function (option) {
                        return option.type === 'json' ||
                            option.type === propertyMapper[row.type] ||
                            option.type === row.type ||
                            propertyMapper[option.type] === propertyMapper[row.type] ||
                            propertyMapper[option.type] === row.type;
                    }) }, key(index, row.id, sourcePatch.id, targetPatch.id)));
            });
        };
        return _this;
    }
    PropertiesMapper.prototype.render = function () {
        var _a = this.props, hideTitle = _a.hideTitle, edgeMeta = _a.edgeMeta, sourcePatch = _a.sourcePatch, targetPatch = _a.targetPatch, onTargetUpdated = _a.onTargetUpdated;
        var targetOptions = [
            { label: 'Allowed', value: '' },
            { label: 'Blocked', value: 'root' },
        ];
        var selectedOption = targetOptions.find(function (to) { return to.value === edgeMeta.transition.target; });
        var isLogic = targetPatch.type === 'logic';
        var isMenu = targetPatch.type === 'navigation' && targetPatch.navigation !== 'submenu';
        return (_jsxs(PropertiesPage, __assign({ hideTitle: true }, { children: [_jsxs(PropertiesGroup, { children: [!hideTitle && _jsx(H4, { children: "Connection" }), !isLogic && !isMenu && sourcePatch.type !== 'navigation' && (_jsxs(_Fragment, { children: [_jsx(H5, __assign({ style: { marginBottom: 1 } }, { children: "Back Navigation" })), _jsx(P, __assign({ detail: true, style: {
                                        fontSize: 11,
                                        marginBottom: 5,
                                    } }, { children: _jsx("span", __assign({ style: { fontStyle: 'italic' } }, { children: "When we navigate between these two patches configure if it is possible to go back" })) })), _jsx(Select, { name: "target", value: selectedOption, options: targetOptions, onChange: function (option) {
                                        return onTargetUpdated((option && option.value) || '');
                                    }, onKeyDown: function (e) { return e.stopPropagation(); }, isClearable: true })] }))] }), _jsxs(PropertiesGroup, { children: [_jsx(H5, __assign({ style: { marginBottom: 1 } }, { children: "Properties Mapper" })), _jsx(P, __assign({ detail: true, style: {
                                fontSize: 11,
                                marginBottom: 5,
                            } }, { children: _jsx("span", __assign({ style: { fontStyle: 'italic' } }, { children: "Configure what data with matching data types is passed from one patch to another" })) })), sourcePatch &&
                            sourcePatch.type !== 'navigation' &&
                            this.renderRowComponent()] })] })));
    };
    return PropertiesMapper;
}(React.PureComponent));
export { PropertiesMapper };
